import { app } from '../../../../../app';
import { Controller } from './password-policy.controller';

app.component('companyManageApplicationPasswordPolicy', {
    bindings: {
        application: '<',
        companyId: '<',
        currentPasswordAuthenticationSettings: '<',
    },
    controller: Controller,
    templateUrl: require('./password-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/password-policy/password-policy.component.js